import { NgModule, Optional, SkipSelf } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { FavouriteItemEffects } from './favourite-item.effects';
import { IFavouriteItemFeature } from './favourite-item.feature.state';
import { FavouriteItemReducer } from './favourite-item.reducer';
import { nameof } from '@symphony-solo/shared/utils/src';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IFavouriteItemFeature>('favouriteItemFeature'), FavouriteItemReducer),
    EffectsModule.forFeature([FavouriteItemEffects]),
  ],
})
export class FavouriteItemStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: FavouriteItemStateModule
  ) {
    if (parentModule) {
      throw new Error('FavouriteItemStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
